import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Dialog as MuiDialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import React, { useState } from "react";
import { IMarketCampaignChannel } from "../../redux/marketCampaign/marketCampaign.types";
import { PreviewTemplate } from "../Preview/PreviewTemplate";
import { ControlledCustomSelect } from "../formsComponents";
import { CountryCodeSelector } from "../CountrySelector";
import { validatePhoneNumber, getMaxPhoneLength, getPhoneLengthHint } from "../../constants/phoneConfig";
import { CustomTextField } from "../formsComponents/CustomTextField";
import { LoadState } from "../../constants/enums";
import { FileUpload } from "../FileUpload/components/FileUpload";
import { useBillingCompanyContext } from "../../providers";
import { useDispatchWrapper } from "../../hooks";
import { IWhatsAppActivityPayload } from "../../redux/activity/activity.types";
import { upsertWhatsAppMessage } from "../../redux/activity/activityActions";
import { showMessage } from "../../redux/messages/messagesActions";
import {
  fetchCampaignSqlQueryResultAsync,
  fetchQuickSendCampaignListAsync,
  runQuickCampaign,
  upsertDraftStepAsync,
  upsertMarketCampaignBasicInfoAsync,
  upsertMarketCampaignChannelAsync,
} from "../../redux/marketCampaign/marketCampaignActions";
import { useNavigate } from "react-router-dom";
import SendIcon from "@mui/icons-material/Send";
import LoadingDialogWithMessage from "../Dialogs/LoadingDialogWithMessage";
import { formatText } from "../../helpers";
import { PageLoader } from "../PageLoader/PageLoader";
import { useMarketCampaignContext } from "../../views/market-campaign/MarketCampaign.context-state";
import { useReduxStore } from "../../redux/store.hooks";
import WhatsappBgImg from "../../assets/whatsapp_bg_img.jpg";
import { ILead } from "../../redux/leads/leads.types";
import { IUpsellInsight } from "../../views/upselling/types/upsell.types";
import { getUpsellDataKeys } from "../../helpers/extractUpsellDataKeys";
import {
  IWhatsAppTemplateData,
  IWhatsAppTemplateHeader,
} from "../../redux/whatsappTemplate/whatsappTemplate.types";
import { uploadFile } from "../FileUpload/utils";
import { extractHeaders } from "../../views/marketingCampaign/components/ExcelFileUplaodButtonAsyncV2";
import { Step4MarketCampaignSchedule } from "../../views/market-campaign/campaign-steps";
import { Dialog } from "../Dialogs/Dialog";
import { withS3Prefix } from "../../helpers/withS3Prefix";
import { getHeaderTypeFromFile } from "../FileUploadIcon/helpers";
import { config } from "../../config";
import { MuiNumberField } from "../formsComponents/MuiNumberField";
import { useAuth } from "../../contexts/AuthProvider";
import { isMetaProvider } from "../../contexts/AuthProvider/AuthProvider.helpers";

interface TemplateDetailsV2Props {
  template: IWhatsAppTemplateData;
  values: IMarketCampaignChannel;
  closeBtnClicked?: boolean;
  showButtons?: boolean;
  leadData?: ILead | null;
  upsellData?: IUpsellInsight[] | null;
  onNext: () => void;
  onClose: () => void;
  toNumber?: string;
  isLocked?: boolean
  startConversationToNumber?: string;
  onDialogClose?: () => void; // Callback to close the parent dialog (e.g., SelectWhatsappTemplate)
}

export const TemplateDetailsV2: React.FC<TemplateDetailsV2Props> = ({
  template,
  values,
  closeBtnClicked,
  onNext,
  onClose,
  showButtons = true,
  onDialogClose,
  leadData,
  upsellData,
  toNumber,
  isLocked
}) => {
  const {
    comapny: { company_outlet_uuid, company_outlet_name },
  } = useBillingCompanyContext();

  const { whatsappService, country } = useAuth();
  const isMetaAvailable = isMetaProvider(whatsappService);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const {
    marketCampaign: campaignBasicInfo,
    state,
    onStateChange,
    draftSteps,
    isCompleted,
    isEditable: isEditCampaignAllowed,
    isAutoGenerating,
    isReadyToExecution,
    isAutoGenerationFailed,
  } = useMarketCampaignContext();

  const {
    list: quickSendList,
    headers: tableHeaders,
    loading: quickSendLoading,
  } = useReduxStore("marketCampaign").marketCampaignQuickSend;

  const { list: campaignSqlQueryResult } =
    useReduxStore("marketCampaign").campaignSqlQueryResult;

  const { data: templateData, dataLoading: templateDataLoading } =
    useReduxStore("marketCampaign").marketCampaignChannel;

  const shouldIncludeButton =
    template?.buttons?.buttons?.length > 0 &&
    template?.buttons?.buttons[0]?.type?.toLowerCase() === "url" &&
    template?.buttons?.buttons[0]?.example?.[0];

  const headerComponent = template?.components?.find((comp: any) =>
    comp.type === "HEADER" && (comp as any).example?.header_handle?.length > 0,
  ) as IWhatsAppTemplateHeader | undefined;

  const [isSaveTemplateDisabled, setIsSaveTemplateDisabled] = useState(false);
  const [headerMedia, setHeaderMedia] = useState<File | null>(null);
  const [templateHeaderMediaValue, setTemplateHeaderMediaValue] = useState<string>("");

  const [headerType, setHeaderType] = useState(closeBtnClicked ? template?.header?.format || headerComponent?.format
    : templateData?.header_media?.[0]?.type
      ? templateData?.header_media[0]?.type
      : template?.header?.format || headerComponent?.format,
  );

  const [moduleVariables, setModuleVariables] = useState(
    closeBtnClicked
      ? Array(
        (template?.body?.text?.match(/\{\{[^}]+\}\}/g) || []).length,
      ).fill({
        type: "TEXT",
        value: "",
      })
      : templateData
        ? templateData?.module_variables_columns_name?.map((v) => ({
          type: v.type || "TEXT",
          value: v.value || "",
        }))
        : Array(
          (template?.body?.text?.match(/\{\{[^}]+\}\}/g) || []).length,
        ).fill({
          type: "TEXT",
          value: "",
        }),
  );
  const [headerMediaType, setHeaderMediaType] = useState("UPLOAD");
  const [buttonVariableType, setButtonVariableType] = useState<string>("TEXT");
  const [buttonVariableValue, setButtonVariableValue] = useState<string>(
    template?.buttons?.buttons?.[0]?.example?.[0] || ""
  );
  // console.log("template ===> ", {
  //   closeBtnClicked,
  //   headerComponent,
  //   templateData,
  //   template,
  //   templateHeaderMediaValue,
  //   headerMedia,
  //   headerMediaType, moduleVariables, headerType,
  //   draftSteps
  // })
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [isSending, setIsSending] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = React.useState({
    dialCode: country.dialCode,
    isoCode: country.code,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSavingTemplate, setIsSavingTemplate] = useState(false);
  const [isRunTemplate, setIsRunTemplate] = useState(false);
  const [isScheduleTemplate, setIsScheduleTemplate] = useState(false);
  const [openConfimationDialog, setOpenConfimationDialog] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState<
    "run" | "schedule" | null
  >(null);
  const [openStep4MarketCampaignSchedule, setOpenStep4MarketCampaignSchedule] =
    useState(
      campaignBasicInfo.sending_type === "SCHEDULING" ||
        campaignBasicInfo.status === "DONE"
        ? true
        : false,
    );
  const [otpEntered, setOtpEntered] = useState<string>("");

  const isPhoneNumberValid = phoneNumber.length > 0 && validatePhoneNumber(selectedCountryCode.dialCode, phoneNumber).isValid;

  const previewTemplateData = () => {
    if (!closeBtnClicked) {
      // Use saved_template_data consistently for both DONE/RUNNING status and SAVE DETAILS
      const savedTemplateData =
        draftSteps?.draft_step_data?.step_three_data?.saved_template_data;

      if (savedTemplateData) {
        // Merge saved template data with template
        return {
          ...template,
          ...savedTemplateData,
          header_media: savedTemplateData.header_media || [],
          attachment: savedTemplateData.attachment || "",
          module_variables_columns_name:
            savedTemplateData.module_variables_columns_name || [],
        } as IWhatsAppTemplateData;
      } else {
        return template as IWhatsAppTemplateData;
      }
    } else {
      return template as IWhatsAppTemplateData;
    }
  };

  // Function to check if there are any changes in header or body variables
  const hasChanges = () => {
    // Check if header media has changed from the original template
    const originalHeaderValue = templateData?.header_media?.[0]?.value || "";
    const headerChanged =
      headerMedia !== null || // New file uploaded
      templateHeaderMediaValue !== originalHeaderValue; // Header value changed from original

    // Check if body variables have changed from their initial state
    const bodyChanged = moduleVariables.some((variable, index) => {
      // Get the original value from template data or template body example
      const originalValue =
        templateData?.module_variables_columns_name?.[index]?.value ||
        template?.body?.example?.body_text?.[index] ||
        "";
      return variable?.value?.trim() !== String(originalValue).trim();
    });

    // Check if button variable has changed from the template default
    const originalButtonValue =
      (templateData as any)?.buttonVar?.[0]?.value ||
      template?.buttons?.buttons?.[0]?.example?.[0] ||
      "";
    const buttonChanged =
      shouldIncludeButton &&
      buttonVariableValue?.trim() !== String(originalButtonValue).trim();

    return headerChanged || bodyChanged || buttonChanged;
  };

  const handleHeaderMediaChange = (file: File) => {
    setHeaderMedia(file);
  };

  const handleHeaderMediaDelete = () => {
    setHeaderMedia(null);
    setTemplateHeaderMediaValue("");
  };

  const handleVariableChange = (
    index: number,
    field: string,
    value: string,
  ) => {
    const newVariables = [...moduleVariables];
    if (field === "type") {
      newVariables[index] = { ...newVariables[index], [field]: value, value: "" };
    } else {
      newVariables[index] = { ...newVariables[index], [field]: value };
    }
    setModuleVariables(newVariables);
  };

  const handleHeaderMediaTypeChange = (value: string) => {
    setHeaderMediaType(value);
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const maxLen = getMaxPhoneLength(selectedCountryCode.dialCode);

    if (/^\d*$/.test(value) && value.length <= maxLen) {
      setPhoneNumber(value);
    }
  };

  const isFormValid = (requirePhoneNumber: boolean = false) => {
    if (
      template?.header?.format &&
      template?.header?.format !== "TEXT" &&
      !headerMedia &&
      !templateHeaderMediaValue
    )
      return false;

    const allBodyVariablesFilled = moduleVariables?.every(
      (variable) => variable?.value?.trim() !== "",
    );
    if (!allBodyVariablesFilled) return false;

    if (shouldIncludeButton && !buttonVariableValue?.trim()) return false;

    if (requirePhoneNumber && !isPhoneNumberValid) return false;

    if (
      template.category === "AUTHENTICATION" &&
      (!otpEntered || otpEntered.length !== 6)
    )
      return false;

    return true;
  };

  const handleWhatsAppSend = async (leadPhoneNumber?: string) => {
    if (!template || !isFormValid()) return;

    setIsSending(true);
    setIsSavingTemplate(false);

    try {
      let headerUrl = templateHeaderMediaValue ? templateHeaderMediaValue : "";

      if (headerMedia) {
        headerUrl = await uploadFile({
          file: headerMedia,
          module_name: "WHATSAPP_MARKET_CAMPAIGN",
          defaultReturn: headerMedia.name || "",
          asPayload: {
            template_name: template.name,
            company_outlet_uuid: company_outlet_uuid,
          },
          onWarning: (message) => {
            dispatch(
              showMessage({
                type: "warning",
                message: message,
                displayAs: "snackbar",
              }),
            );
          },
        });
      }

      let bodyVar;

      if (template.category === "AUTHENTICATION") {
        // For authentication templates, send OTP as a single body variable
        bodyVar = [{ type: "text", value: otpEntered }];
      } else {
        // For regular templates, send all module variables
        bodyVar = moduleVariables.map((variable, index) => ({
          type: "text",
          value: variable.value || "TEST_VALUE",
        }));
      }

      // const orderedBodyVars = moduleVariables.map((variable, index) => ({
      //       type: "text",
      //       value: variable.value || "TEST_VALUE",
      //     }));

      let buttonVar;

      if (template.category === "AUTHENTICATION") {
        buttonVar = [
          {
            sub_type: "url",
            type: "button",
            value: otpEntered,
            index: 0,
            payload_type: "text",
          },
        ];
      } else {
        buttonVar = [
          {
            sub_type: template?.buttons?.buttons[0]?.type.toLowerCase(),
            // type: template?.buttons?.type,
            type: "BUTTON",
            payload_type: buttonVariableType,
            value: buttonVariableValue || template?.buttons?.buttons[0]?.example?.[0] || "",
          },
        ];
      }

      // const buttonVar = [
      //   {
      //     sub_type: template?.buttons?.buttons[0]?.type.toLowerCase(),
      //     // type: template?.buttons?.type,
      //     type: "BUTTON",
      //     value: template?.buttons?.buttons[0]?.example?.[0] || "",
      //   },
      // ];
      const payload: IWhatsAppActivityPayload = {
        fromNumber: null,
        toNumber: leadPhoneNumber
          ? leadPhoneNumber
          : selectedCountryCode.dialCode + phoneNumber,
        is_automatic_message: 0,
        templateName: template.name,
        company_outlet_uuid: company_outlet_uuid,
        company_outlet_name: company_outlet_name,
        objectVariables: {
          // ...(orderedBodyVars.length > 0 && {
          //   bodyVar: orderedBodyVars,
          // }),
          ...(bodyVar.length > 0 && {
            bodyVar: bodyVar,
          }),
          ...(headerUrl &&
            ["IMAGE", "DOCUMENT", "VIDEO"].includes(headerType ?? "")
            ? {
              headerVar: [
                {
                  type: headerType?.toLowerCase(), // "image" or "document"
                  // value: headerMedia
                  //   ? `${config.assets.s3BaseUrl}/${headerUrl}`
                  //   : headerUrl,
                  // value: `${config.assets.s3BaseUrl}/${headerUrl}`,
                  value: headerUrl,
                },
              ],
            }
            : {}),
          ...(buttonVar &&
            template?.buttons?.buttons?.length > 0 &&
            template?.buttons?.buttons[0]?.type.toLowerCase() === "url" &&
            template?.buttons?.buttons[0]?.example?.[0] && {
            buttonVar: buttonVar,
          }),
        },
        whatsapp_web_service: !isMetaAvailable,
        reference_uuid_column_name: "recepient_number",
        reference_uuid_column_value: toNumber,
      };

      const authPayload: IWhatsAppActivityPayload = {
        fromNumber: null,
        toNumber: leadPhoneNumber
          ? leadPhoneNumber
          : selectedCountryCode.dialCode + phoneNumber,
        is_automatic_message: 0,
        templateName: template.name,
        company_outlet_uuid: company_outlet_uuid,
        company_outlet_name: company_outlet_name,
        objectVariables: {
          ...(bodyVar.length > 0 && {
            bodyVar: bodyVar,
          }),

          ...(buttonVar && {
            buttonVar: buttonVar,
          }),
        },
        whatsapp_web_service: !isMetaAvailable,
        reference_uuid_column_name: "recepient_number",
        reference_uuid_column_value: toNumber,
      };

      dispatch(
        upsertWhatsAppMessage(
          template.category === "AUTHENTICATION" ? authPayload : payload,
          whatsappService.selectedService,
          (isSuccess) => {
            setIsSending(false);
            dispatch(
              showMessage({
                type: isSuccess ? "success" : "error",
                message: isSuccess
                  ? "Test message sent successfully"
                  : "Failed to send test message",
                displayAs: "snackbar",
              }),
            );
            // Close the dialog only on successful send
            if (isSuccess && onDialogClose) {
              onDialogClose();
            }
          },
        ),
      );
    } catch (error) {
      setIsSending(false);
      dispatch(
        showMessage({
          type: "error",
          message: "File upload failed",
          displayAs: "snackbar",
        }),
      );
    }
  };

  const handleQuickRun = () => {
    setIsRunTemplate(true);
    const templateData = {
      headerMedia,
      headerType,
      moduleVariables,
      phoneNumber,
      buttonVariableValue,
      buttonVariableType,
    };

    const moduleVariablesPayload =
      moduleVariables && moduleVariables.length > 0
        ? moduleVariables.map((v) => ({
          type: v.type || "",
          value: v.value || "",
        }))
        : [];

    const button_variable_column_name = shouldIncludeButton
      ? [
        {
          type: buttonVariableType.toLowerCase(),
          value: buttonVariableValue || template?.buttons?.buttons[0]?.example?.[0] || "",
          sub_type: template?.buttons?.buttons[0]?.type?.toLowerCase() || "",
        },
      ]
      : [];

    const payload = {
      ...values,
      market_campaign_channel_unique_id:
        values.market_campaign_channel_unique_id,
      market_campaign_channel_uuid: values.market_campaign_channel_uuid,
      market_campaign_uuid: values.market_campaign_uuid,
      market_campaign_channel_name: values.market_campaign_channel_name,
      template_name: values.template_name,
      template_uuid: values.template_uuid,

      header_media:
        headerType === "TEXT"
          ? null
          : headerType !== "" && headerMedia
            ? [
              {
                type: headerType || "",
                value: headerMedia
                  ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
                  : withS3Prefix(templateHeaderMediaValue),
              },
            ]
            : values.header_media && values.header_media[0]?.type !== ""
              ? values.header_media.map((hm) => ({
                type: headerType || hm.type,
                value: withS3Prefix(hm.value || templateHeaderMediaValue),
              }))
              : [],

      module_variables_columns_name: moduleVariablesPayload,
      button_variable_column_name: button_variable_column_name,
      company_outlet_uuid: company_outlet_uuid,
      attachment: headerMedia
        ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
        : withS3Prefix(templateHeaderMediaValue),
    };

    dispatch(
      upsertMarketCampaignChannelAsync(
        payload,
        values?.header_media?.[0]?.type === "UPLOAD" ? headerMedia : null,
        true,
        (isSuccess, path) => {
          dispatch(
            upsertMarketCampaignBasicInfoAsync(
              {
                ...campaignBasicInfo,
                sending_type: "QUICK",
                campaign_start_date: new Date().toISOString(),
                campaign_end_date: new Date().toISOString(),
              },
              (data) => {
                dispatch(
                  upsertDraftStepAsync(
                    {
                      ...draftSteps,
                      current_step: 3,
                      draft_step_data: {
                        ...draftSteps.draft_step_data,
                        step_three_data: {
                          ...(path && { file_path: path }),
                          button: "Run Campaign",
                          saved_template_data: isSuccess,
                          template_data: templateData,
                          campaign_info: {
                            ...campaignBasicInfo,
                            sending_type: "QUICK",
                            status: "DONE",
                          },
                          selected_template: template,
                        },
                      },
                    },
                    (isSuccess) => {
                      if (isSuccess && values.market_campaign_uuid) {
                        dispatch(
                          runQuickCampaign(
                            values.market_campaign_uuid,
                            (runSuccess) => {
                              if (runSuccess) {
                                navigate("/market-campaign");
                                setIsRunTemplate(false);
                              }
                            },
                          ),
                        );
                      }
                    },
                  ),
                );
              },
            ),
          );
        },
      ),
    );
  };

  const handleScheduleCampaign = () => {
    setIsScheduleTemplate(true);
    dispatch(
      upsertMarketCampaignBasicInfoAsync(
        {
          ...campaignBasicInfo,
          sending_type: "SCHEDULING",

          // status: "SCHEDULED",
        },
        (campaignResponse) => {
          const moduleVariablesPayload =
            moduleVariables && moduleVariables.length > 0
              ? moduleVariables.map((v) => ({
                type: v.type || "",
                value: v.value || "",
              }))
              : [];

          const button_variable_column_name = shouldIncludeButton
            ? [
              {
                type: buttonVariableType.toLowerCase(),
                value: buttonVariableValue || template?.buttons?.buttons[0]?.example?.[0] || "",
                sub_type: template?.buttons?.buttons[0]?.type?.toLowerCase() || "",
              },
            ]
            : [];

          const payload = {
            ...values,
            market_campaign_channel_unique_id:
              values.market_campaign_channel_unique_id,
            market_campaign_channel_uuid: values.market_campaign_channel_uuid,
            market_campaign_uuid: values.market_campaign_uuid,
            market_campaign_channel_name: values.market_campaign_channel_name,
            template_name: values.template_name,
            template_uuid: values.template_uuid,

            header_media:
              headerType === "TEXT"
                ? null
                : headerType !== "" && headerMedia
                  ? [
                    {
                      type: headerType || "",
                      value: headerMedia
                        ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
                        : withS3Prefix(templateHeaderMediaValue),
                    },
                  ]
                  : values.header_media && values.header_media[0]?.type !== ""
                    ? values.header_media.map((hm) => ({
                      type: headerType || hm.type,
                      value:
                        withS3Prefix(hm.value || templateHeaderMediaValue),
                    }))
                    : [],

            module_variables_columns_name: moduleVariablesPayload,
            button_variable_column_name: button_variable_column_name,
            company_outlet_uuid: company_outlet_uuid,
            attachment: headerMedia
              ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
              : withS3Prefix(templateHeaderMediaValue),
          };

          dispatch(
            upsertMarketCampaignChannelAsync(
              payload,
              values?.header_media?.[0]?.type === "UPLOAD" ? headerMedia : null,
              true,
              (isSuccess, path) => {
                dispatch(
                  upsertDraftStepAsync(
                    {
                      ...draftSteps,
                      // current_step: 3,
                      draft_step_data: {
                        ...draftSteps.draft_step_data,
                        step_three_data: {
                          ...(path && { file_path: path }),
                          button: "Schedule Campaign",
                          saved_template_data: isSuccess,
                          template_data: templateData,
                          selected_template: template,
                          campaignBasicInfo: {
                            ...campaignResponse,
                          },
                        },
                      },
                    },
                    (draftState) => {
                      onStateChange({
                        ...state,
                        draftSteps: draftState,
                        marketCampaign: campaignResponse,
                        // completionSteps: {
                        //   ...state.completionSteps,
                        //   step3: true,
                        // },
                        // activeStep: 3,
                        // maxAllowedSteps: 3,
                      });

                      setOpenStep4MarketCampaignSchedule(true);
                    },
                  ),
                );

                setIsScheduleTemplate(false);
              },
            ),
          );
        },
      ),
    );
  };

  const handleSaveTemplateDetails = () => {
    setIsSending(true);
    setIsSavingTemplate(true);

    const templateData = {
      headerMedia,
      headerType,
      moduleVariables,
      phoneNumber,
      buttonVariableValue,
      buttonVariableType,
    };

    const button_variable_column_name = shouldIncludeButton
      ? [
        {
          type: buttonVariableType.toLowerCase(),
          value: buttonVariableValue || template?.buttons?.buttons[0]?.example?.[0] || "",
          sub_type: template?.buttons?.buttons[0]?.type?.toLowerCase() || "",
        },
      ]
      : [];

    const payload = {
      ...values,
      market_campaign_channel_unique_id:
        values.market_campaign_channel_unique_id,
      market_campaign_channel_uuid: values.market_campaign_channel_uuid,
      market_campaign_uuid: values.market_campaign_uuid,
      market_campaign_channel_name: values.market_campaign_channel_name,
      template_name: values.template_name,
      template_uuid: values.template_uuid,

      header_media:
        headerType === "TEXT"
          ? null
          : headerType !== "" && headerMedia
            ? [
              {
                type: headerType || "",
                value: headerMedia
                  ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
                  : withS3Prefix(templateHeaderMediaValue),
              },
            ]
            : values.header_media && values.header_media[0]?.type !== ""
              ? values.header_media.map((hm) => ({
                type: headerType || hm.type,
                value: withS3Prefix(hm.value || templateHeaderMediaValue),
              }))
              : [],

      module_variables_columns_name: moduleVariables.map((v) => ({
        type: v.type,
        value: v.value,
      })),
      button_variable_column_name: button_variable_column_name,

      company_outlet_uuid: company_outlet_uuid,

      attachment: headerMedia
        ? `${config.assets.s3BoilerplateUrl}${headerMedia?.name}`
        : withS3Prefix(templateHeaderMediaValue),
    };

    dispatch(
      upsertMarketCampaignChannelAsync(
        payload,
        headerMedia
          ? headerMedia
          : values?.header_media?.length === 0
            ? null
            : undefined,
        false,
        (isSuccess, path) => {
          dispatch(
            upsertDraftStepAsync(
              {
                ...draftSteps,
                current_step: 2,
                draft_step_data: {
                  ...draftSteps.draft_step_data,
                  step_three_data: {
                    ...(path && { file_path: path }),
                    button: "Save Details",
                    saved_template_data: isSuccess,
                    template_data: templateData,
                    selected_template: template,
                  },
                },
              },
              (draftStepData) => {
                onStateChange({
                  ...state,
                  draftSteps: draftStepData,
                });

                setIsSending(false);
                setIsSavingTemplate(false);
              },
            ),
          );
        },
      ),
    );
  };

  const upsellDataKeys = React.useMemo(() => {
    // New API structure: leads are directly in the leads array of each upsell data item
    const firstUpsellItem = upsellData?.[0];
    if (
      firstUpsellItem &&
      "leads" in firstUpsellItem &&
      firstUpsellItem.leads?.[0]
    ) {
      return getUpsellDataKeys(firstUpsellItem.leads[0]);
    }

    return [];
  }, [upsellData]);

  const draftStepOptions =
    draftSteps?.draft_step_data?.step_three_data?.saved_template_data?.module_variables_columns_name?.map(
      (v: any) => ({
        label: v.value,
        value: v.value,
      }),
    );

  const hideSelectField =
    campaignSqlQueryResult.length === 0 &&
    draftSteps?.draft_step_data?.step_two_data?.type === "DATABASE_RULES";
  console.log("campaignSqlQueryResult ===> ", {
    campaignBasicInfo,
    campaignSqlQueryResult,
    draftSteps
  })
  const isValidKey = (key: string) => {
    return !/(^id$|_id$|uuid|_uuid)/i.test(key);
  };

  const getSelectOptions = (variableIndex: number) => {
    if (
      upsellDataKeys.length > 0 &&
      (!tableHeaders || tableHeaders.length === 0)
    ) {
      return upsellDataKeys.map((key) => ({
        label: formatUpsellKey(key),
        value: key,
      }));
    }

    if (draftSteps?.is_upsell_generated === 1) {
      return draftStepOptions;
    }

    if (
      campaignSqlQueryResult.length !== 0 &&
      draftSteps?.draft_step_data?.step_two_data?.type === "DATABASE_RULES"
    ) {
      return extractHeaders(campaignSqlQueryResult)
        .filter(isValidKey)
        .map((header) => ({
          label: formatText(header),
          value: header,
        }));
    }

    return tableHeaders.map((header) => ({
      label: formatText(header),
      value: header,
    }));
  };

  const formatUpsellKey = (key: string): string => {
    return key
      .split(".")
      .map((part) =>
        part
          .replace(/[\[\]0-9]/g, "")
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      )
      .join(" → ");
  };

  React.useEffect(() => {
    if (!campaignBasicInfo.market_campaign_uuid) {
      return;
    }

    if (draftSteps?.is_upsell_generated === 1) {
      return;
    }

    if (draftSteps?.draft_step_data?.step_two_data?.database_rules) {
      return;
    }

    const loadData = async () => {
      try {
        await dispatch(
          fetchQuickSendCampaignListAsync({
            market_campaign_uuid: campaignBasicInfo.market_campaign_uuid,
            company_outlet_uuid: company_outlet_uuid,
            pageNo: 1,
            itemPerPage: 100,
            pageLimit: 100,
          }),
        );

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    loadData();
  }, [campaignBasicInfo.market_campaign_uuid, draftSteps?.is_upsell_generated]);

  React.useEffect(() => {
    if (draftSteps?.draft_step_data?.step_three_data?.file_path) {
      setTemplateHeaderMediaValue(
        draftSteps?.draft_step_data?.step_three_data?.file_path,
      );
    }

    if (template && template.attachment) {

      if (Array.isArray(template.attachment) && template.attachment?.length > 0) {
        setTemplateHeaderMediaValue(template.attachment[0])
        setHeaderType(getHeaderTypeFromFile(template.attachment[0]))
      }
      if (template.attachment && template.attachment?.length > 0) {
        const filepath = template.attachment as any as string ?? ""
        setTemplateHeaderMediaValue(filepath)
        setHeaderType(getHeaderTypeFromFile(filepath))
      }

      setHeaderType(headerType);
    }

    if (!showButtons) {
      setIsLoading(false);
    }
  }, []);
  React.useEffect(() => {
    if (!isEditCampaignAllowed) {
      setIsSaveTemplateDisabled(true);
      return;
    }

    if (draftSteps?.is_upsell_generated === 1) {
      setIsSaveTemplateDisabled(true);
      return;
    }
    // Enable save button if form is valid and there are changes
    if (isFormValid() && hasChanges()) {
      setIsSaveTemplateDisabled(false);
      return;
    }

    // Original logic for other cases
    if (closeBtnClicked && isFormValid()) {
      setIsSaveTemplateDisabled(false);
    } else if (templateHeaderMediaValue) {
      setIsSaveTemplateDisabled(true);
    } else {
      setIsSaveTemplateDisabled(!isFormValid());
    }
  }, [
    isEditCampaignAllowed,
    closeBtnClicked,
    isFormValid,
    templateHeaderMediaValue,
    moduleVariables,
    headerMedia,
    hasChanges,
  ]);

  React.useEffect(() => {
    const savedTemplateData =
      draftSteps?.draft_step_data?.step_three_data?.saved_template_data;

    const dataToUse = savedTemplateData;

    if (dataToUse && !closeBtnClicked) {
      if (dataToUse.header_media && dataToUse.header_media.length > 0) {
        setHeaderType(dataToUse.header_media[0].type || "");
        const headerMediaValue = dataToUse.header_media[0].value || "";
      }

      // Set module variables
      if (
        dataToUse.module_variables_columns_name &&
        dataToUse.module_variables_columns_name.length > 0
      ) {
        setModuleVariables(dataToUse.module_variables_columns_name);
      } else if (template.body?.text) {
        // If no saved variables, initialize from template body text
        const variableMatches =
          template.body.text.match(/\{\{[^}]+\}\}/g) || [];
        setModuleVariables(
          Array(variableMatches.length)
            .fill(null)
            .map(() => ({
              type: "TEXT",
              value: "",
            })),
        );
      }

      if (dataToUse.phone_number) {
        setPhoneNumber(dataToUse.phone_number);
      }

      if (dataToUse.buttonVariableValue) {
        setButtonVariableValue(dataToUse.buttonVariableValue);
      }
      if (dataToUse.buttonVariableType) {
        setButtonVariableType(dataToUse.buttonVariableType);
      }
    } else if (template.body?.text && moduleVariables.length === 0) {
      const variableMatches = template.body.text.match(/\{\{[^}]+\}\}/g) || [];
      if (variableMatches.length > 0) {
        setModuleVariables(
          Array(variableMatches.length)
            .fill(null)
            .map(() => ({
              type: "TEXT",
              value: "",
            })),
        );
      }
    }
  }, [
    draftSteps,
    template.body?.text,
    moduleVariables.length,
    closeBtnClicked,
  ]);


  React.useEffect(() => {
    console.log("campaignSqlQueryResult 1===>", {
      database_rules: draftSteps?.draft_step_data?.step_two_data?.database_rules,
      market_campaign_uuid: campaignBasicInfo.market_campaign_uuid
    })

    if (draftSteps?.draft_step_data?.step_two_data?.database_rules) {
      console.log("campaignSqlQueryResult 2===>", {
        database_rules: draftSteps?.draft_step_data?.step_two_data?.database_rules,
        market_campaign_uuid: campaignBasicInfo.market_campaign_uuid
      })
      dispatch(
        fetchCampaignSqlQueryResultAsync(
          campaignBasicInfo.market_campaign_uuid,
        ),
      );
    }
  }, [campaignBasicInfo.market_campaign_uuid]);



  return (
    <>
      <PageLoader
        loading={
          templateDataLoading === LoadState.InProgress ||
          quickSendLoading === LoadState.InProgress ||
          isLoading
        }
      >
        <Box sx={{ p: `${isDesktop ? 3 : 0}`, position: "relative" }}>
          <LoadingDialogWithMessage
            open={
              isSending ||
              isSavingTemplate ||
              isRunTemplate ||
              isScheduleTemplate
            }
            label={
              isSavingTemplate
                ? "Saving Template Details..."
                : isRunTemplate
                  ? "Running Campaign..."
                  : isScheduleTemplate
                    ? "Scheduling Campaign..."
                    : "Sending Template Message to Entered WhatsApp Number"
            }
          />

          <Grid
            spacing={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 8,
              mr: `${isDesktop ? 6 : 0}`,
              flexDirection: `${isDesktop ? "row" : "column"}`,
            }}
          >
            {!isDesktop && (
              <Grid item xs={12} md={4}>
                <Box
                  borderRadius={2}
                  sx={{
                    position: "sticky",
                    top: 20,
                    backgroundColor: "#efeae2",
                    backgroundImage: `url(${WhatsappBgImg})`,
                    minHeight: "55vh",
                    backgroundSize: "auto",
                    // backgroundPosition: "center",
                    backgroundRepeat: "repeat",
                    mb: 2,
                    display: "flex",
                    backgroundBlendMode: "multiply",

                    pl: 4,
                    pb: 4,
                    pr: 10,
                    alignItems: "flex-end",
                  }}
                >
                  <Box mt={4}>
                    <PreviewTemplate
                      template={previewTemplateData()}
                      loading={LoadState.InProgress}
                      headerType={headerType ?? ""}
                      headerMedia={headerMedia}
                      bodyVariableValues={moduleVariables?.reduce(
                        (acc, item, index) => {
                          if (item.value) {
                            acc[index + 1] = item.value;
                          }
                          return acc;
                        },
                        {} as { [key: string]: string },
                      )}
                      bodyVariableTypes={moduleVariables?.reduce(
                        (acc, item, index) => {
                          if (item.type) {
                            acc[index + 1] = item.type;
                          }
                          return acc;
                        },
                        {} as { [key: string]: string },
                      )}
                    />
                  </Box>
                </Box>
              </Grid>
            )}

            {/* Left side - Form controls */}
            <Grid item xs={12} md={6}>
              <Box mb={4}>
                <Typography variant="h6" gutterBottom fontWeight={700}>
                  Header
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ backgroundColor: "primary.main" }}>
                      <TableRow>
                        <TableCell sx={{ color: "#fff" }}>#</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Variable</TableCell>
                      </TableRow>
                    </TableHead>

                    {headerType && headerType !== "TEXT" ? (
                      <TableBody>
                        <TableRow>
                          <TableCell>1</TableCell>
                          <TableCell>
                            <ControlledCustomSelect
                              fullWidth
                              value={headerMediaType}
                              options={[
                                { label: "Upload", value: "UPLOAD" },
                                // { label: "Select", value: "SELECT" },
                              ]}
                              onChange={(e) =>
                                handleHeaderMediaTypeChange(
                                  e.target.value as string,
                                )
                              }
                              displayEmpty
                              placeholder="Select type"
                              disabled={!isEditCampaignAllowed || isLocked}
                            />
                          </TableCell>
                          <TableCell>
                            {headerMediaType === "UPLOAD" ? (
                              <FileUpload
                                accept={
                                  headerType === "IMAGE"
                                    ? `image/*`
                                    : headerType === "VIDEO"
                                      ? "video/*"
                                      : headerType === "DOCUMENT"
                                        ? ".pdf"
                                        : ""
                                }
                                onChange={handleHeaderMediaChange}
                                onDelete={handleHeaderMediaDelete}
                                value={templateHeaderMediaValue}
                                disabled={!isEditCampaignAllowed || isLocked}
                                deleteDisabled={!isEditCampaignAllowed || isLocked}
                              />
                            ) : (
                              <ControlledCustomSelect
                                fullWidth
                                value={""}
                                options={[]}
                                onChange={() => { }}
                                displayEmpty
                                placeholder="Select variable"
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={3}>No Headers found</TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Box>

              <Box>
                <Typography variant="h6" gutterBottom fontWeight={700}>
                  Body Variables
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ backgroundColor: "primary.main" }}>
                      <TableRow>
                        <TableCell sx={{ color: "#fff" }}>#</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Value</TableCell>
                      </TableRow>
                    </TableHead>

                    {moduleVariables?.length > 0 ||
                      (template.body?.text &&
                        template.body.text.match(/\{\{[^}]+\}\}/g)) ? (
                      <TableBody>
                        {moduleVariables.map((variable, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>

                            <TableCell>
                              <ControlledCustomSelect
                                fullWidth
                                value={variable.type}
                                options={
                                  hideSelectField
                                    ? [{ label: "Text", value: "TEXT" }]
                                    : [
                                      { label: "Text", value: "TEXT" },
                                      { label: "Select", value: "SELECT" },
                                    ]
                                }
                                onChange={(e) =>
                                  handleVariableChange(
                                    index,
                                    "type",
                                    e.target.value as string,
                                  )
                                }
                                disabled={
                                  !isEditCampaignAllowed ||
                                  draftSteps?.is_upsell_generated === 1 || isLocked
                                }
                              />
                            </TableCell>
                            <TableCell>
                              {variable.type === "TEXT" ? (
                                <CustomTextField
                                  fullWidth
                                  value={variable.value}
                                  onChange={(e) =>
                                    handleVariableChange(
                                      index,
                                      "value",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Enter value"
                                  error={!variable.value.trim()}
                                  helperText={
                                    !variable.value.trim()
                                      ? "Required field"
                                      : ""
                                  }
                                  disabled={!isEditCampaignAllowed || isLocked}
                                />
                              ) : !hideSelectField &&
                                variable.type === "SELECT" ? (
                                <ControlledCustomSelect
                                  fullWidth
                                  value={variable.value}
                                  options={getSelectOptions(index)}
                                  onChange={(e) =>
                                    handleVariableChange(
                                      index,
                                      "value",
                                      e.target.value as string,
                                    )
                                  }
                                  displayEmpty
                                  placeholder="Select column"
                                  disabled={!isEditCampaignAllowed || isLocked}
                                />
                              ) : (
                                <></>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={3}>No variables found</TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Box>

              {shouldIncludeButton && (
                <Box mb={4} mt={4}>
                  <Typography variant="h6" gutterBottom fontWeight={600}>
                    Button Variables
                  </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ backgroundColor: "primary.main" }}>
                        <TableRow>
                          <TableCell sx={{ color: "#fff" }}>#</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>1</TableCell>
                          <TableCell>
                            <ControlledCustomSelect
                              fullWidth
                              value={buttonVariableType}
                              options={
                                hideSelectField
                                  ? [{ label: "Text", value: "TEXT" }]
                                  : [
                                    { label: "Text", value: "TEXT" },
                                    { label: "Select", value: "SELECT" },
                                  ]
                              }
                              onChange={(e) => {
                                setButtonVariableType(e.target.value as string);
                                setButtonVariableValue("");
                              }}
                              disabled={!isEditCampaignAllowed || draftSteps?.is_upsell_generated === 1 || isLocked}
                            />
                          </TableCell>
                          <TableCell>
                            {buttonVariableType === "TEXT" ? (
                              <CustomTextField
                                fullWidth
                                value={buttonVariableValue}
                                onChange={(e) => setButtonVariableValue(e.target.value)}
                                label={template?.buttons?.buttons[0]?.url || ""}
                                placeholder={`e.g. ${template?.buttons?.buttons[0]?.example?.[0] || ""}`}
                                error={!buttonVariableValue?.trim()}
                                helperText={
                                  !buttonVariableValue?.trim()
                                    ? "Required field"
                                    : `URL format: ${template?.buttons?.buttons[0]?.url || ""}`
                                }
                                disabled={!isEditCampaignAllowed || isLocked}
                              />
                            ) : !hideSelectField && buttonVariableType === "SELECT" ? (
                              <ControlledCustomSelect
                                fullWidth
                                value={buttonVariableValue}
                                options={getSelectOptions(100)}
                                onChange={(e) => setButtonVariableValue(e.target.value as string)}
                                displayEmpty
                                placeholder="Select column"
                                disabled={!isEditCampaignAllowed || isLocked}
                              />
                            ) : (
                              <></>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}

              {!showButtons && template.category === "AUTHENTICATION" && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="h6" gutterBottom fontWeight={700}>
                    OTP Value
                  </Typography>

                  <MuiNumberField
                    label=""
                    name="otpValue"
                    value={otpEntered}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow numeric input and limit to 6 digits
                      if (/^\d*$/.test(value) && value.length <= 6) {
                        setOtpEntered(value);
                      }
                    }}
                    placeholder="Enter OTP"
                    error={
                      otpEntered.length > 0 && otpEntered.length !== 6
                        ? "OTP must be exactly 6 digits"
                        : ""
                    }
                  />
                </Box>
              )}

              {showButtons &&
                (() => {
                  // const hasNoHeader = !headerType || headerType === "TEXT";
                  const hasNoHeader = !headerType;
                  const hasNoBodyVariables =
                    !moduleVariables?.length &&
                    (!template.body?.text ||
                      !template.body.text.match(/\{\{[^}]+\}\}/g));

                  const shouldHideSaveDetails =
                    hasNoHeader && hasNoBodyVariables;

                  return !shouldHideSaveDetails ? (
                    <Grid xs={12} sx={{ mt: 2 }}>
                      <Button
                        fullWidth
                        disabled={isSaveTemplateDisabled}
                        variant="contained"
                        size="large"
                        onClick={handleSaveTemplateDetails}
                      >
                        Save Details
                      </Button>
                    </Grid>
                  ) : null;
                })()}
              {showButtons && (
                <Grid
                  xs={12}
                  md={12}
                  mt={3}
                  sx={{
                    display: "flex",

                    justifyContent: "space-between",
                  }}
                >
                  <Grid xs={12} md={12} sx={{ width: "100%" }}>
                    <Typography variant="h6" gutterBottom fontWeight={700}>
                      Test Recipients (optional)
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        position: "relative",
                        gap: 2,
                      }}
                    >
                      <Box sx={{ maxWidth: 90 }}>
                        <CountryCodeSelector
                          value={selectedCountryCode.isoCode}
                          sx={{ height: 36 }}
                          onChange={(newCountry) => setSelectedCountryCode({
                            dialCode: newCountry.dialCode,
                            isoCode: newCountry.code,
                          })}
                          disabled={isCompleted || isLocked}
                        />
                      </Box>
                      <CustomTextField
                        fullWidth
                        variant="outlined"
                        label="Enter phone number"
                        value={phoneNumber}
                        disabled={isCompleted || isLocked}
                        onChange={handlePhoneNumberChange}
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        error={phoneNumber.length > 0 && !isPhoneNumberValid}
                        helperText={
                          phoneNumber.length > 0 && !isPhoneNumberValid
                            ? `Please enter a valid phone number (${getPhoneLengthHint(selectedCountryCode.dialCode)})`
                            : ""
                        }
                      />

                      <Button
                        variant="contained"
                        onClick={() => handleWhatsAppSend()}
                        disabled={
                          !isFormValid(true) || isSending || isCompleted || isLocked
                        }
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          minWidth: "150px",
                        }}
                      >
                        <Typography>Test Template</Typography>
                        <SendIcon
                          sx={{
                            pb: 1,
                            rotate: "-45deg",

                            color: `${!isFormValid(true) || isSending
                              ? "inherit"
                              : "white"
                              }`,
                          }}
                        />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              )}

              {!showButtons && (
                <Grid xs={12} mt={3}>
                  <Button
                    fullWidth
                    disabled={!isFormValid(false) || isSending || isCompleted}
                    variant="contained"
                    onClick={() =>
                      handleWhatsAppSend(
                        leadData?.contact_number_one
                          ? leadData?.contact_number_one
                          : toNumber
                            ? toNumber
                            : "",
                      )
                    }
                    sx={{
                      display: "flex",

                      gap: 2,
                    }}
                  >
                    <Typography>Send Message</Typography>
                    <SendIcon
                      sx={{
                        pb: 1,
                        rotate: "-45deg",

                        color: `${!isFormValid(true) || isSending ? "inherit" : "white"
                          }`,
                      }}
                    />
                  </Button>
                </Grid>
              )}

              {showButtons && (
                <Grid
                  xs={12}
                  gap={2}
                  mt={3}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: `${isDesktop ? "row" : "column"}`,
                    mb: 2,
                  }}
                >
                  <Grid xs={12} md={6}>
                    <Button
                      fullWidth
                      disabled={
                        campaignBasicInfo.status === "SCHEDULED" ||
                        !isFormValid() ||
                        !isEditCampaignAllowed ||
                        isAutoGenerating ||
                        isAutoGenerationFailed
                      }
                      variant="contained"
                      size="large"
                      onClick={() => {
                        setConfirmationAction("run");
                        setOpenConfimationDialog(true);
                      }}
                    >
                      Run Campaign
                    </Button>
                  </Grid>
                  <Grid xs={12} md={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      size="large"
                      // onClick={handleScheduleCampaign}
                      onClick={() => {
                        if (campaignBasicInfo?.sending_type === "SCHEDULING") {
                          setOpenStep4MarketCampaignSchedule(true);
                        } else {
                          setConfirmationAction("schedule");
                          setOpenConfimationDialog(true);
                        }
                      }}
                      disabled={
                        !isFormValid() ||
                        !isEditCampaignAllowed ||
                        isAutoGenerating ||
                        isAutoGenerationFailed ||
                        !values?.market_campaign_channel_name ||
                        !values?.market_campaign_channel_uuid ||
                        (values?.module_variables_columns_name?.length > 0 &&
                          values.module_variables_columns_name.some(
                            (item) => !item,
                          ))
                      }
                    >
                      Schedule Campaign
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>

            {/* Right side - Preview */}
            {isDesktop && (
              <Grid item xs={12} md={4} mt={4}>
                <Box
                  borderRadius={2}
                  sx={{
                    position: "sticky",
                    top: 20,
                    backgroundColor: "#efeae2",
                    backgroundImage: `url(${WhatsappBgImg})`,
                    minHeight: "55vh",
                    backgroundSize: "auto",
                    // backgroundPosition: "center",
                    backgroundRepeat: "repeat",
                    backgroundBlendMode: "multiply",
                    mb: 2,
                    display: "flex",
                    pl: 4,
                    pb: 4,
                    pr: 10,
                    alignItems: "flex-end",
                  }}
                >
                  <Box mt={4}>
                    <PreviewTemplate
                      template={previewTemplateData()}
                      loading={LoadState.InProgress}
                      headerType={headerType || ""}
                      headerMedia={headerMedia}
                      bodyVariableValues={moduleVariables?.reduce(
                        (acc, item, index) => {
                          if (item.value) {
                            acc[index + 1] = item.value;
                          }
                          return acc;
                        },
                        {} as { [key: string]: string },
                      )}
                      bodyVariableTypes={moduleVariables?.reduce(
                        (acc, item, index) => {
                          if (item.type) {
                            acc[index + 1] = item.type;
                          }
                          return acc;
                        },
                        {} as { [key: string]: string },
                      )}
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>

        <MuiDialog
          open={openConfimationDialog}
          onClose={() => {
            setOpenConfimationDialog(false);
            setConfirmationAction(null);
          }}
        >
          <DialogContent>
            <DialogContentText>
              {confirmationAction === "run"
                ? "Are you sure you want to run this campaign now?"
                : "Are you sure you want to schedule this campaign?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfimationDialog(false);
                setConfirmationAction(null);
              }}
              color="primary"
              variant="outlined"
            >
              No
            </Button>
            <Button
              onClick={() => {
                setOpenConfimationDialog(false);
                if (confirmationAction === "run") {
                  handleQuickRun();
                } else if (confirmationAction === "schedule") {
                  handleScheduleCampaign();
                }
                setConfirmationAction(null);
              }}
              color="primary"
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </MuiDialog>
      </PageLoader>

      {openStep4MarketCampaignSchedule && (
        <Dialog
          open={true}
          title={
            campaignBasicInfo.status === "DONE"
              ? "Run Campaign"
              : "Schedule Campaign"
          }
          size={campaignBasicInfo.status === "DONE" ? "sm" : "md"}
          onClose={() => setOpenStep4MarketCampaignSchedule(false)}
        >
          <Step4MarketCampaignSchedule
            onFinish={() => navigate("/market-campaign")}
          />
        </Dialog>
      )}
    </>
  );
};
